import styles from "./About.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";
import image1 from "../assets/about103.jpg";
import image2 from "../assets/about105.jpg";
import image3 from "../assets/about106.jpg";
import image4 from "../assets/about107.jpg";
import image5 from "../assets/about108.jpg";
import image6 from "../assets/about109.jpg";

export const About = () => {
    return (
        <section className={styles.about}>
            <div className={styles.aboutText}>
                Dr. Oleg Torsunov is a leading expert in Ayurveda and a
                world-renowned psychologist with a PhD in Medical Science. He
                regularly delivers lectures across the U.S., Canada, the UAE,
                Europe, India, Russia, Ukraine, Thailand, and Australia. Today,
                his Ayurvedic health and wellness methods are practiced by
                hundreds of thousands of people in more than 60 countries
                worldwide.
            </div>
            <div className={styles.descriptionContainer}>
                <div
                    className={classNames(styles.descriptionColumn, {}, [
                        styles.descriptionText,
                    ])}
                >
                    <p>
                        These methods teach stress relief and how to restore
                        strength and vitality and slow down the aging process.
                        They are designed specifically to alleviate tension in
                        both the body and mind, which accumulates as a response
                        to excessive emotional, mental and physical strains.
                    </p>
                </div>
            </div>
            <div className={styles.gallery}>
                <img src={image1} alt="" className={styles.item1} />
                <img src={image2} alt="" className={styles.item2} />
                <img src={image3} alt="" className={styles.item3} />
                <img src={image4} alt="" className={styles.item4} />
                <img src={image5} alt="" className={styles.item5} />
                <img src={image6} alt="" className={styles.item6} />
            </div>
        </section>
    );
};
